export default "__VITE_ASSET__5M2j$iWq__"